// extracted by mini-css-extract-plugin
export default {"login":"style_login__Bxvdr","button":"style_button__JpQFU"};